import { FixedPageHeader } from "@/components/ui/fixed-page-header";
import { PAGE_HEADERS } from "@/constants/page-headers";
import { KpiActualsSection } from "@/components/crm/KpiActualsSection";
import { KpiOpportunitiesSection } from "@/components/crm/KpiOpportunitiesSection";
import { KpiPipelineSection } from "@/components/crm/KpiPipelineSection";
import { useKpiMetrics } from "@/hooks/use-kpi-metrics";
import { Loader2 } from "lucide-react";
import { AppSidebar } from "@/components/AppSidebar";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";

const CrmKpi = () => {
  const { actualsQuery, pipelineQuery } = useKpiMetrics();

  const isLoading = actualsQuery.isLoading || pipelineQuery.isLoading;

  if (isLoading) {
    return (
      <SidebarProvider>
        <div className="min-h-screen flex w-full bg-background">
          <AppSidebar />
          <SidebarInset>
            <FixedPageHeader {...PAGE_HEADERS.crmKpi} />
            <div className="flex items-center justify-center" style={{ paddingTop: "8.5rem", minHeight: "calc(100vh - 8.5rem)" }}>
              <div className="text-center">
                <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
                <p className="mt-2 text-muted-foreground">Loading KPI metrics...</p>
              </div>
            </div>
          </SidebarInset>
        </div>
      </SidebarProvider>
    );
  }

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
        <SidebarInset>
          <FixedPageHeader {...PAGE_HEADERS.crmKpi} />
          <div className="px-4 md:px-8 py-6 md:py-8 space-y-8" style={{ paddingTop: "8.5rem" }}>
            <KpiActualsSection metrics={actualsQuery.data} />
            <KpiOpportunitiesSection metrics={pipelineQuery.data} />
            <KpiPipelineSection metrics={pipelineQuery.data} />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default CrmKpi;
